import { isMobileScreen } from '@apply/ui';
import { EditButton } from './components/EditButton';
import { DeleteButton } from './components/DeleteButton';

export interface ActionsCellProps {
    experienceId: number | undefined;
    experienceTypeId: number | undefined;
    isVerified: boolean;
}

export const ActionsCell: React.FC<ActionsCellProps> = ({ experienceId, experienceTypeId, isVerified }) => {
    const mobileScreen = isMobileScreen();
    if (!experienceId) return null;

    return (
        <div
            style={{
                display: 'flex',
                width: '100%',
                justifyContent: mobileScreen ? 'flex-end' : 'center',
                textAlign: mobileScreen ? 'right' : 'center',
            }}
        >
            <EditButton
                experienceId={experienceId}
                experienceTypeId={experienceTypeId}
                isVerified={isVerified}
            />
            <DeleteButton
                experienceId={experienceId}
                experienceTypeId={experienceTypeId}
                isVerified={isVerified}
            />
        </div>
    );
};
